import React, { FunctionComponent } from 'react'
import { ViewStyle } from 'react-native'
import Svg, {
  ClipPath,
  Defs,
  FeBlend,
  FeFlood,
  FeGaussianBlur,
  Filter,
  G,
  LinearGradient,
  Path,
  Rect,
  Stop,
} from 'react-native-svg'

import { tID } from '../../utils/utils'

// useId is available in React 18 but @types/react is locked to v17
const useId = (React as any).useId as () => string

export interface InsightsOrbIconProps {
  size?: number
  style?: ViewStyle
}

export const InsightsOrbIcon: FunctionComponent<InsightsOrbIconProps> = ({ size = 24, style }) => {
  const uniqueId = useId()
  const clipId = `clip0_orb_${uniqueId}`
  const filter0Id = `filter0_orb_${uniqueId}`
  const filter1Id = `filter1_orb_${uniqueId}`
  const paint0Id = `paint0_orb_${uniqueId}`
  const paint1Id = `paint1_orb_${uniqueId}`

  return (
    <Svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      testID={tID('InsightsOrbIcon')}
      style={style}
      accessible={false}
      accessibilityElementsHidden={true}
      importantForAccessibility='no'
    >
      <G clipPath={`url(#${clipId})`}>
        <G filter={`url(#${filter0Id})`}>
          <Path
            d='M18.2341 15.6002C16.2463 19.0433 11.8435 20.223 8.40041 18.2351C4.95727 16.2472 3.77757 11.8445 5.76546 8.40138C7.75336 4.95825 12.1561 3.77855 15.5992 5.76644C19.0423 7.75433 20.222 12.157 18.2341 15.6002Z'
            fill={`url(#${paint0Id})`}
            fillOpacity={0.9}
          />
        </G>
        <G filter={`url(#${filter1Id})`}>
          <Path
            d='M15.0818 15.0818C13.3795 16.7841 10.6196 16.7841 8.91733 15.0818C7.21506 13.3795 7.21506 10.6196 8.91733 8.91733C10.6196 7.21506 13.3795 7.21506 15.0818 8.91733C16.7841 10.6196 16.7841 13.3795 15.0818 15.0818Z'
            fill={`url(#${paint1Id})`}
          />
        </G>
      </G>
      <Defs>
        <Filter id={filter0Id} x='-1.0802' y='-1.07922' width='26.1604' height='26.1604' filterUnits='userSpaceOnUse'>
          <FeFlood floodOpacity={0} result='BackgroundImageFix' />
          <FeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <FeGaussianBlur stdDeviation={2.94} result='effect1_foregroundBlur' />
        </Filter>
        <Filter id={filter1Id} x='4.65247' y='4.65247' width='14.6941' height='14.6951' filterUnits='userSpaceOnUse'>
          <FeFlood floodOpacity={0} result='BackgroundImageFix' />
          <FeBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <FeGaussianBlur stdDeviation={1.49408} result='effect1_foregroundBlur' />
        </Filter>
        <LinearGradient
          id={paint0Id}
          x1='9.36486'
          y1='2.16704'
          x2='12.6034'
          y2='20.6617'
          gradientUnits='userSpaceOnUse'
        >
          <Stop offset='0.221403' stopColor='#FFD971' />
          <Stop offset='0.906996' stopColor='#FF7700' />
        </LinearGradient>
        <LinearGradient id={paint1Id} x1='11.9995' y1='5.8351' x2='10.9952' y2='17.1597' gradientUnits='userSpaceOnUse'>
          <Stop offset='0.221403' stopColor='#FFD971' />
          <Stop offset='0.906996' stopColor='#FF7700' />
        </LinearGradient>
        <ClipPath id={clipId}>
          <Rect width='24' height='24' fill='white' />
        </ClipPath>
      </Defs>
    </Svg>
  )
}
